<ng-container *ngIf="awardsCountryBandData">
  <!-- DISPLAY UPGRADE MESSAGE IF SPECTRUM LIGHT -->
  <div class="SpectrumLight-alert" *ngIf="awardsCountryBandData.light">
    <div class="Alert Alert--basic">
      <h3>You need to <b>upgrade your subscription</b> to access all the data in this application.</h3>
    </div>
    <a routerLink='/upgrade/' class="Button Button--blue" (click)="analyticsService.pushUpgradeButtonClickEvent()"><span>Upgrade</span></a>
  </div>
  <div class="TableTitle TableTitle--inlineBlock">
    <h2 class="Country">Country</h2>&nbsp;&nbsp;/&nbsp;&nbsp;<h2 class="Bands">Band</h2>
    <h1><a (click)="analyticsService.pushTitleClickEvent()" routerLink='/awards/'>Awards</a> in <a (click)="analyticsService.pushTitleClickEvent()" [routerLink]="'/awards/country/'+awardsCountryBandData.countryCode">{{ ('CountryNames.' + awardsCountryBandData.countryCode) | translate }}</a> in the <a (click)="analyticsService.pushTitleClickEvent()" [routerLink]="'/awards/country/'+awardsCountryBandData.bandCode">{{ ('Band.' + awardsCountryBandData.bandCode) | translate }}</a> band</h1>
  </div>
  <table class="table ResponsiveTable ResponsiveTable--withHeaderMobile" *ngIf="awardsCountryBandData.awards.length > 0" datatable [dtOptions]="dtOptions">
    <thead class="AnimatedThead">
      <tr>
        <th scope="col">Award</th>
        <th scope="col">Title</th>
        <th scope="col">Status</th>
        <th scope="col">
          MHz awarded<br>
          <span>(in band)</span>
        </th>
        <th scope="col">
          Price paid<br>
          <span>(in band)</span>
        </th>
        <th scope="col">Price/MHz</th>
        <th scope="col">Price/MHz/pop.</th>
        <th scope="col">Cullen report</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of awardsCountryBandData.awards">
        <td data-th="Award" [class.EmptyCell]="!row.awardKey">
          <a [routerLink]="'/awards/'+row.awardKey">{{ row.awardKey | delete2FirstChar }}</a>
        </td>
        <td data-th="Title" [class.EmptyCell]="!row.shortTitle">
          {{ row.shortTitle }}
        </td>
        <td data-th="Status" [class.EmptyCell]="hideStatus(row)">
          <div *ngIf="row.status">{{ row.status }}</div>
          <!-- LIGHT COMMENT -->
          <div *ngIf="row.statusComment && row.statusComment != 'BLUR_COMMENT'" class="RichText" [class.DisplayNone]="row.statusComment.length===1" [innerHtml]="row.statusComment | forceTarget"></div>
        </td>
        <td data-th="MHz awarded (in band)" [class.EmptyCell]="!row.priceDetails.mhzAwarded" [class.HideCellOnMobile]="displayService.hideCellOnMobile(row.priceDetails.mhzAwarded)">
          <!-- LIGHT CONTENT -->
          <span [innerHtml]="isSpectrumLightContent(row.priceDetails.mhzAwarded)"></span>
        </td>
        <ng-container *ngIf="currencyService.isEuro()">
          <td data-th="Price paid (in band)" [class.EmptyCell]="!row.priceDetails.pricePaid.priceEUR" [class.HideCellOnMobile]="displayService.hideCellOnMobile(row.priceDetails.pricePaid.priceEUR)" [attr.data-order]="row.priceDetails.pricePaid.priceOrderEUR">
            <!-- LIGHT CONTENT -->
            <span [innerHtml]="isSpectrumLightContent(row.priceDetails.pricePaid.priceEUR)"></span>
          </td>
          <td data-th="Price per MHz" [class.EmptyCell]="!row.priceDetails.pricePerMhz.priceEUR" [class.HideCellOnMobile]="displayService.hideCellOnMobile(row.priceDetails.pricePerMhz.priceEUR)" [attr.data-order]="row.priceDetails.pricePerMhz.priceOrderEUR">
            <!-- LIGHT CONTENT -->
            <span [innerHtml]="isSpectrumLightContent(row.priceDetails.pricePerMhz.priceEUR)"></span>
          </td>
          <td data-th="Price per MHz and population" class="NoWrap" [class.EmptyCell]="!row.priceDetails.pricePerMhzPerPerson.priceEUR" [class.HideCellOnMobile]="displayService.hideCellOnMobile(row.priceDetails.pricePerMhzPerPerson.priceEUR)" [attr.data-order]="row.priceDetails.pricePerMhzPerPerson.priceOrderEUR">
            <!-- LIGHT CONTENT -->
            <span [innerHtml]="isSpectrumLightContent(row.priceDetails.pricePerMhzPerPerson.priceEUR)"></span>
          </td>
        </ng-container>
        <ng-container *ngIf="!currencyService.isEuro()">
          <td data-th="Price paid (in band)" [class.EmptyCell]="!row.priceDetails.pricePaid.priceUSD" [class.HideCellOnMobile]="displayService.hideCellOnMobile(row.priceDetails.pricePaid.priceUSD)" [attr.data-order]="row.priceDetails.pricePaid.priceOrderUSD">
            <!-- LIGHT CONTENT -->
            <span [innerHtml]="isSpectrumLightContent(row.priceDetails.pricePaid.priceUSD)"></span>
          </td>
          <td data-th="Price per MHz" [class.EmptyCell]="!row.priceDetails.pricePerMhz.priceUSD" [class.HideCellOnMobile]="displayService.hideCellOnMobile(row.priceDetails.pricePerMhz.priceUSD)" [attr.data-order]="row.priceDetails.pricePerMhz.priceOrderUSD">
            <!-- LIGHT CONTENT -->
            <span [innerHtml]="isSpectrumLightContent(row.priceDetails.pricePerMhz.priceUSD)"></span>
          </td>
          <td data-th="Price per MHz and population" class="NoWrap" [class.EmptyCell]="!row.priceDetails.pricePerMhzPerPerson.priceUSD" [class.HideCellOnMobile]="displayService.hideCellOnMobile(row.priceDetails.pricePerMhzPerPerson.priceUSD)" [attr.data-order]="row.priceDetails.pricePerMhzPerPerson.priceOrderUSD">
            <!-- LIGHT CONTENT -->
            <span [innerHtml]="isSpectrumLightContent(row.priceDetails.pricePerMhzPerPerson.priceUSD)"></span>
          </td>
        </ng-container>
        <td data-th="Cullen report" class="NoWrap" [class.EmptyCell]="row.reports.length===0">
          <div *ngFor="let report of row.reports" class="Loop">
            <a [href]="getDocumentUrl(report.uniqueNumber)" target="fromSpectrum" *ngIf="report.displayName">
              {{ report.displayName | capitalize }}
            </a>
            <a [href]="getDocumentUrl(report.uniqueNumber)" target="fromSpectrum" *ngIf="!report.displayName">
              {{ displayService.displayReportNames(report.uniqueNumber) }}
            </a>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
  <div class="NoResult" *ngIf="awardsCountryBandData.awards.length===0 && !awardsCountryBandData.light">
    <p>No award registered in the database</p>
  </div>
  <div class="NoResult" *ngIf="awardsCountryBandData.awards.length===0 && awardsCountryBandData.light">
    <p>No award registered in the database or Upgrade your subscription</p>
  </div>
</ng-container>
